module.exports = __webpack_public_path__ + "static/media/lock.538fee99.svg";